import {useMutation, useQuery, useQueryClient, UseQueryResult} from '@tanstack/react-query';
import {EditProjectStoryDTO, projectStoriesApi, ProjectStoryDetailedModel} from '../api';
import {useNotifications} from '../../../shared';

export const useProjectStoryById = (storyId: string) => {
  const queryClient = useQueryClient();
  const {createNotification} = useNotifications();

  const getStory: UseQueryResult<ProjectStoryDetailedModel, Error> = useQuery({
    queryKey: ['project-story', storyId],
    queryFn: () => projectStoriesApi.getProjectStoryById(storyId),
    enabled: !!storyId,
    staleTime: 60 * 1000,
  });

  const refetchStory = () => {
    getStory.refetch();
  };

  const updateProjectStoryMutation = useMutation({
    mutationFn: ({storyId, dto}: {storyId: string; dto: EditProjectStoryDTO}) =>
      projectStoriesApi.updateProjectStory(storyId, dto),
    onSuccess: (_, {storyId}) => {
      queryClient.invalidateQueries({queryKey: ['projectStories', 'infinite'], refetchType: 'all'});
      queryClient.invalidateQueries({queryKey: ['project-story', storyId]});
      createNotification({
        title: 'Новость проекта успешно обновлена',
        name: 'updateProjectStory',
        theme: 'success',
      });
    },
  });
  const deleteProjectStoryMutation = useMutation({
    mutationFn: projectStoriesApi.deleteProjectStory,
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ['project-story', storyId]});
      queryClient.invalidateQueries({queryKey: ['projectStories', 'infinite'], refetchType: 'all'});
      createNotification({
        title: 'Новость проекта успешно удалена',
        name: 'deleteProjectStory',
        theme: 'success',
      });
    },
  });

  return {
    getStory,
    refetchStory,
    deleteProjectStoryMutation,
    updateProjectStoryMutation,
  };
};
